export const validateIPAddress = (ipAddress) => {
  const pattern =
    /^((([1-9]|1\d|2[0-4])\d|25[0-5]|\d)\.){3}(([1-9]|1\d|2[0-4])\d|25[0-5]|\d)$/;
  return pattern.test(ipAddress);
};
